module.exports = __webpack_public_path__ + "static/media/copy-icon.ff0e48f2.svg";